module.exports = __webpack_public_path__ + "static/img/tekst-80px.6271f735.png";